<template>
  <div>
    <vx-card>
      <vs-table pagination :max-items="10" search :data="_prosecutions">

        <template slot="header" vs-justify="flex-end">
          <router-link :to="{name: 'prosecution-userJob-add'}" >
            <vs-button vs-order="5" radius color="primary" icon-pack="feather" icon="icon-plus" v-if="pms ('ProsecutionUserJob', 'create', 'b')"></vs-button>
          </router-link>
        </template>

        <template slot="thead">
          <vs-th sort-key="caseNumber">{{ $t('sections.prosecution.dataForm.caseNumber') }}</vs-th>
          <vs-th sort-key="sendInformationContractToLawyerDate">{{ $t('sections.prosecution.dataForm.sendInformationContractToLawyerDate') }}</vs-th>
          <vs-th sort-key="prosecutionType">{{ $t('sections.prosecution.dataForm.prosecutionType') }}</vs-th>
          <vs-th sort-key="contractName">{{ $t('sections.prosecution.dataForm.contractName') }}</vs-th>
          <vs-th sort-key="contractNo">{{ $t('sections.prosecution.dataForm.contractNo') }}</vs-th>
          <vs-th sort-key="total">{{ $t('sections.prosecution.dataForm.totalAsset') }}</vs-th>
          <vs-th sort-key="caseStatus">สถานะ</vs-th>
          <vs-th sort-key="" class="w-1/12"></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="row" :key="index" v-for="(row, index) in data">
            <vs-td :data="row.caseNumber">
              {{ row.caseNumber }}
            </vs-td>
            <vs-td :data="row.sendInformationContractToLawyerDate">
              {{ row.sendInformationContractToLawyerDate | convYYYYMMDDToDDMMYYYY }}
            </vs-td>
            <vs-td :data="row.prosecutionTypeName">
              {{ row.prosecutionTypeName }}
            </vs-td>
            <vs-td :data="row.contractName">
            {{ row.contractName }}
            </vs-td>
            <vs-td :data="row.contractNo">
              {{ row.contractNo}}
            </vs-td>
            <vs-td :data="row.total">
              {{ row.total | numberFormat }}
            </vs-td>
            <vs-td :data="row.caseStatusName">
              <vs-chip :color="row.caseStatus | caseStatusColor" class="product-order-status">{{ row.caseStatusName  }}</vs-chip>
            </vs-td>
            <vs-td>
              <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                <vx-tooltip text="ดูข้อมูลการดำเนินคดี">
                  <vs-button class="p-5" color="success" type="flat" icon-pack="feather" icon="icon-menu" @click="transaction(row)"  v-if="visibilityView(row)"></vs-button>
                </vx-tooltip>
                <vx-tooltip text="ยืนการส่งข้อมูลฝ่ายกฎหมาย">
                  <vs-button class="p-5" color="success" type="flat" icon-pack="feather" icon="icon-check-square" @click="approved(row.id)"  v-if="visibilityApproved(row)"></vs-button>
                </vx-tooltip>
                <vx-tooltip text="แก้ไขข้อมูล">
                  <vs-button class="p-5" color="warning" type="flat" icon-pack="feather" icon="icon-edit" @click="edit(row.id)"  v-if="visibilityEdit(row)"></vs-button>
                </vx-tooltip>
                <vx-tooltip text="ลบข้อมูล">
                  <vs-button class="p-5" color="danger" type="flat" icon-pack="feather" icon="icon-trash" @click="del(row.id)"  v-if="visibilityDel(row)"></vs-button>
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import {ICaseStatus} from "@/constants/interface";
const {mapActions: mapProsecutionActions, mapState: mapProsecutionState } = createNamespacedHelpers('Prosecution')

export default {
  async created () {
    const vm = this
    await vm.reloadComponent(vm.$route.params);
  },
  computed: {
    ...mapProsecutionState(['prosecutions', 'status']),
    currentUser () {
      if(!this.$store.state.currentUser){
        return null
      }
      return {
        id: this.$store.state.currentUser.id,
        email: this.$store.state.currentUser.email,
        role: this.$store.state.currentUser.role
      }
    },
    isRoot(){
      if(!this.currentUser){
        return false
      }
      const { isRoot } = this.currentUser.role
      return isRoot
    },
    isLawyer(){
      if(!this.currentUser){
        return false
      }
      return this.currentUser.role.type === 'lawyer'
    },
    isLegalCounsel(){
      if(!this.currentUser){
        return false
      }
      return this.currentUser.role.type === 'legalCounsel'
    },
    isUser(){
      if(!this.currentUser){
        return false
      }
      return this.currentUser.role.type === ('normal' || 'super')
    },
    _prosecutions(){
      const vm = this;
      return vm.prosecutions.map(prosecution => {
        return {
          ...prosecution,
          sendInformationContractToLawyerDate: prosecution.sendInformationContractToLawyerDate,
          caseStatusName: prosecution.caseStatusName,
          createdAt: prosecution.createdAt,
        }
      }).sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt)
      })
    }
  },
  methods: {
    ...mapProsecutionActions(['getProsecutionsUserJob', 'updateProsecutionCaseStatus', 'deleteProsecution']),
    transaction(row){
      const {contract, id: prosecutionId} = row
      const { id: contractId} = contract
      this.$router.push({name: 'prosecution-transaction-detail', params: {contractId, prosecutionId}})
    },
    approved(id){
      const vm = this
      const { updateProsecutionCaseStatus } = vm
      const { dialog } = vm.$vs
      dialog({
        type: 'confirm',
        color: 'success',
        title: 'ยืนยันการส่งข้อมูลให้ฝ่ายกฎหมาย',
        text: 'คุณต้องการส่งข้อมูลให้ฝ่ายกฎหมายใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await updateProsecutionCaseStatus({
            vm,
            id: id,
            form: {
              caseStatus: ICaseStatus.sendInformationContractToLawyer,
              remark: ''
            },
          })
          await vm.reloadComponent(vm.$route.params);
        }
      })
    },
    edit(id){
      this.$router.push({name: 'prosecution-userJob-edit', params: {id}})
    },
    del(id){
      const vm = this
      const { deleteProsecution } = vm
      const { dialog } = vm.$vs
      dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ยืนยันการลบข้อมูล',
        text: 'คุณต้องการลบข้อมูลใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await deleteProsecution({
            form: {
              id: id
            },
            vm
          })
        }
      })
    },
    visibilityView(row){
      return row;
    },
    visibilityApproved({caseStatus, createdBy}){
      const isUserCreated = this.isUser && createdBy.id === this.currentUser.id;
      return caseStatus === ICaseStatus.draft && (this.isRoot || isUserCreated);
    },
    visibilityEdit({caseStatus, createdBy}){
      const isUserCreated = this.isUser && createdBy.id === this.currentUser.id;
      return caseStatus === ICaseStatus.draft && (this.isRoot || isUserCreated);
    },
    visibilityDel({caseStatus, createdBy}){
      const isUserCreated = this.isUser && createdBy.id === this.currentUser.id;
      return caseStatus === ICaseStatus.draft && (this.isRoot || isUserCreated);
    },
    async reloadComponent({ action = null }) {
      await this.getProsecutionsUserJob({ action });
    }
  },
  watch: {
    status: {
      handler(res){
        if(res.processing !== null){
          if(res.processing){
            this.$vs.loading();
          }else{
            this.$vs.loading.close();
          }
        }
        if(res.success !== null){
          this.$vs.notify({...res.success})
        }else if(res.error !== null){
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
    '$route.params': {
      handler(newParams = {}, oldParams = {}) { // ตั้งค่า default เป็น empty object
        if (newParams.action !== oldParams.action) {
          this.reloadComponent(newParams);
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
